import { defineMessages } from 'react-intl';

export default defineMessages({
    riskManagement: {
        id: 'tdic.riskmanagment.detail.Risk Management',
        defaultMessage: 'Risk Management',
    },
    lossPreventionDetails: {
        id: 'tdic.riskmanagment.detail.Loss Prevention Seminar Details',
        defaultMessage: 'Loss Prevention Seminar Details'
    },
    riskManagementInfo: {
        id: 'tdic.riskmanagment.detail.Discounts are applied effective your next policy renewal after course completion.',
        defaultMessage: 'Discounts are applied effective your next policy renewal after course completion.'
    },
    registerLink: {
        id: 'tdic.riskmanagment.detail.Register now',
        defaultMessage: 'Register now'
    },
    riskCourse: {
        id: 'tdic.riskmanagment.detail.for a C.E-eligible course. Manage your risks with',
        defaultMessage: 'for a C.E-eligible course. Manage your risks with'
    },
    guidesLink: {
        id: 'tdic.riskmanagement.detail. tools and guidance',
        defaultMessage: 'tools and guidance'
    },
    linkContent: {
        id: 'tdic.riskmanagment.detail. designed just for dentists.',
        defaultMessage: 'designed just for dentists.'
    },
    name: {
        id: 'tdic.riskmanagment.detail.list.Name',
        defaultMessage: 'Name'
    },
    attended: {
        id: 'tdic.riskmanagment.detail.list.Attended',
        defaultMessage: 'Attended'
    },
    lpsDate: {
        id: 'tdic.riskmanagment.detail.list.LPS Date',
        defaultMessage: 'LPS Date'
    },
    locationCode: {
        id: 'tdic.riskmanagment.detail.list.Location Code',
        defaultMessage: 'Location Code'
    },
    locationName: {
        id: 'tdic.riskmanagment.detail.list.Location Name',
        defaultMessage: 'Location Name'
    },
    startDate: {
        id: 'tdic.riskmanagment.detail.list.Discount Start',
        defaultMessage: 'Discount Start'
    },
    endDate: {
        id: 'tdic.riskmanagment.detail.list.Discount End',
        defaultMessage: 'Discount End'
    },
    noRecords: {
        id: 'tdic.riskmanagment.detail.list.No records found.',
        defaultMessage: 'No records found.'
    },
    rmNotifications: {
        id: 'tdic.riskmanagment.notification.Your Risk Management discount ends on date, Register now and complete an eligible seminar no later than 90 days prior to your end date to continue your Risk Management discount on your Policy, Discounts are applied effective your next policy renewal after course completion.',
        defaultMessage: 'Your {productName} premium discount for completing a risk seminar expires soon. To extend your discount for the next two years, {link} and complete an eligible seminar no later than 90 days prior to {date}. Discounts are applied effective your next policy renewal after course completion.'
    },
    rmNotificationsExpired: {
        id: 'tdic.riskmanagment.notification.Expired risk management, Please register for a new Loss Prevention seminar to continue availing Risk management discount on your Policy',
        defaultMessage: 'Your Risk Management Course {name} expired on {date}. Please register for a new Loss Prevention seminar to continue availing Risk management discount on your Policy {policyNumber}'
    },
    rmNotificationsToday: {
        id: 'tdic.riskmanagment.notification.Risk management is expiring today, Please register for a new Loss Prevention seminar to continue availing Risk management discount on your Policy',
        defaultMessage: 'Your Risk Management Course {name} is expiring on today. Please register for a new Loss Prevention seminar to continue availing Risk management discount on your Policy {policyNumber}'
    }
});
